import { Box, Spacer } from '@chakra-ui/react'
import FormBrandMultiSelect from '../forms/FormBrandMultiSelect'
import FormMemberSelect from '../forms/FormMemberSelect'
import { useGlobalFilterStore } from '../../../stores/globalFilterStore'
import FilterPopover from './FilterPopover'

const GlobalFilterPopover = () => {
  const { member, brands, setMember, setBrands } = useGlobalFilterStore()
  const isActive = !!member || brands.length > 0

  return (
    <FilterPopover subheader="Global filter" isActive={isActive}>
      <Box w={{ base: '100%', md: '300px' }}>
        <FormMemberSelect
          value={member ? { ...member, image: member.image ?? null } : null}
          onAdd={(item) => setMember(item)}
          name="member"
          onRemove={() => {
            setMember(null)
            setBrands([]) // clearing member clears its brands
          }}
        />
        <Spacer h="12px" />
        <FormBrandMultiSelect
          value={brands.map((b) => ({ ...b, logo: b.logo ?? null }))}
          onChange={(items) => setBrands(items)}
          name="brand"
          memberId={member?.id ?? undefined}
        />
      </Box>
    </FilterPopover>
  )
}

export default GlobalFilterPopover
